import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NotificationItemComponentBase } from './core/notification-item-component-base';

/** Represents a Group Post Added notification */
@Component({
  selector: 'dgx-group-post-added',
  template: '<span [innerHTML]="safeContent"></span>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupPostAddedComponent extends NotificationItemComponentBase {
  protected buildTemplate() {
    return this.translateHtml(
      'groupPostAdded_SingleFormat',
      {
        nameHtml: this.userFullNameTemplate,
        groupNameHtml: this.groupNameTemplate,
      }
      // "{{nameHtml}} posted in {{groupNameHtml}}""
    );
  }
}
